"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagHN = function FlagHN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.82.64l2.53,7.58,8,.06a1.08,1.08,0,0,1,.63,2L17.54,15,20,22.59a1.08,1.08,0,0,1-1.65,1.2l-6.5-4.65L5.3,23.79a1.08,1.08,0,0,1-1.65-1.2L6.06,15-.37,10.22A1.08,1.08,0,0,1,.26,8.28l8-.06L10.78.64a1.08,1.08,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.32,21l2.53,7.58,8,.06a1.08,1.08,0,0,1,.63,1.94l-6.43,4.75,2.41,7.62a1.07,1.07,0,0,1-1.65,1.19l-6.5-4.64-6.5,4.64a1.07,1.07,0,0,1-1.65-1.19l2.41-7.62-6.43-4.75a1.08,1.08,0,0,1,.63-1.94l8-.06L-61.36,21a1.08,1.08,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.32-19.7l2.53,7.58,8,.06a1.08,1.08,0,0,1,.63,2L-54.6-5.37l2.41,7.62a1.08,1.08,0,0,1-1.65,1.2l-6.5-4.65-6.5,4.65a1.08,1.08,0,0,1-1.65-1.2l2.41-7.62-6.43-4.74a1.08,1.08,0,0,1,.63-2l8-.06,2.53-7.58a1.08,1.08,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85,21l2.53,7.58,8,.06a1.07,1.07,0,0,1,.63,1.94l-6.42,4.75,2.41,7.62a1.07,1.07,0,0,1-1.65,1.19l-6.5-4.64-6.5,4.64a1.07,1.07,0,0,1-1.65-1.19l2.4-7.62-6.42-4.75a1.07,1.07,0,0,1,.63-1.94l8-.06L82.91,21a1.08,1.08,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85-19.7l2.53,7.58,8,.06a1.08,1.08,0,0,1,.63,2L89.68-5.37l2.41,7.62a1.08,1.08,0,0,1-1.65,1.2L83.94-1.2l-6.5,4.65a1.08,1.08,0,0,1-1.65-1.2l2.4-7.62-6.42-4.74a1.08,1.08,0,0,1,.63-2l8-.06,2.52-7.58a1.08,1.08,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagHN;
exports["default"] = _default;